<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '../../store/authStore';
const route = useRoute();
const store = useAuthStore() as any;
// Only admins manage the business, team, and API keys.
const isAdmin = computed(() => store.user?.role === 'admin');
const is = (path: string) => route.path === path;
</script>

<template>
  <nav class="ss-nav">
    <div class="ss-section">
      <div class="ss-section-label">Account</div>
      <router-link to="/profile" class="ss-item" :class="{ active: is('/profile') }">
        <span class="ss-icon">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
        </span>
        My Profile
      </router-link>
      <router-link to="/change-password" class="ss-item" :class="{ active: is('/change-password') }">
        <span class="ss-icon">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>
        </span>
        Change Password
      </router-link>
    </div>

    <div class="ss-section" v-if="isAdmin">
      <div class="ss-section-label">Business</div>
      <router-link to="/business-profile" class="ss-item" :class="{ active: is('/business-profile') }">
        <span class="ss-icon">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
        </span>
        Business Profile
      </router-link>
      <router-link to="/business" class="ss-item" :class="{ active: is('/business') || is('/users') || is('/add_user') || is('/bulk_invite') || route.path.startsWith('/edituser') }">
        <span class="ss-icon">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
        </span>
        Team Members
      </router-link>
    </div>

    <div class="ss-section" v-if="isAdmin">
      <div class="ss-section-label">Developers</div>
      <router-link to="/developers/api-keys" class="ss-item" :class="{ active: is('/developers/api-keys') }">
        <span class="ss-icon">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>
        </span>
        API Keys
      </router-link>
    </div>
  </nav>
</template>

<style scoped>
.ss-nav {
  width: 210px;
  flex-shrink: 0;
  background: #f8faff;
  border: 1.5px solid #ccdeff;
  border-radius: 14px;
  padding: 16px 10px;
  align-self: flex-start;
  position: sticky;
  top: 24px;
}

.ss-section { margin-bottom: 20px; }
.ss-section:last-child { margin-bottom: 0; }

.ss-section-label {
  font-size: 0.65rem; font-weight: 700; color: #6b86b8;
  text-transform: uppercase; letter-spacing: 0.08em;
  padding: 0 10px; margin-bottom: 4px;
}

.ss-item {
  display: flex; align-items: center; gap: 9px;
  padding: 9px 10px; border-radius: 8px;
  font-size: 0.84rem; font-weight: 500; color: #475569;
  text-decoration: none; transition: background 0.12s, color 0.12s;
  cursor: pointer;
}
.ss-item:hover { background: #edf3ff; color: #0061eb; }
.ss-item.active {
  background: #e8f0ff; color: #0061eb; font-weight: 600;
}
.ss-item.active .ss-icon { color: #0061eb; }

.ss-icon { display: flex; align-items: center; flex-shrink: 0; color: #94a3b8; transition: color 0.12s; }
.ss-item:hover .ss-icon { color: #0061eb; }
</style>
